import { useQuery } from '@apollo/client'
import { getOperationName } from '@apollo/client/utilities'

import {
  GetFeatureTogglesDocument,
  useFeatureToggleUpateMutation,
  useGetFeatureTogglesQuery,
} from '@/generated/graphql'

import { clientFeatureToggleGQL, clientFeatureTogglesCache } from './feature-toggle'

export const useFeatureToggle = (feature: string) => {
  const [dbFeatureToggle] = useFeatureToggleUpateMutation({
    variables: {
      feature,
    },
    refetchQueries: [getOperationName(GetFeatureTogglesDocument)!],
  })

  const clientFeatureToggle = () => {
    const newFeatureToggles = Object.assign({}, clientFeatureTogglesCache())
    newFeatureToggles[feature] = !newFeatureToggles[feature]
    clientFeatureTogglesCache(newFeatureToggles)
  }
  return [dbFeatureToggle, clientFeatureToggle]
}

export const useIsFeatureToggleOn = (
  feature: 'project' | 'onboarding' | 'knowledgeLibrary' | 'impact' | 'banner' | 'anniversaryCard'
) => {
  const { data: featureToggle } = useGetFeatureTogglesQuery()
  const { data: clientFeatureTogglesData } = useQuery(clientFeatureToggleGQL)

  const featureToggles = featureToggle ? featureToggle.featureToggles : []

  return (
    clientFeatureTogglesData.clientFeatureTogglesCache[feature] ||
    featureToggles.some((featureToggle) => featureToggle?.feature === feature && featureToggle?.value === 'true')
  )
}
